module.exports = (__webpack_require__(14))(124);


//////////////////
// WEBPACK FOOTER
// delegated ../../third-party-assemblies/Infragistics/IgniteUI/16.2.20162.2040/css/structure/modules/infragistics.ui.grid.css from dll-reference obpa_dependencies
// module id = 407
// module chunks = 0